
import { saveEmployeeAssessment } from '../../shared/data-services/assessment-service';
export async function sendEmployeeAssessment (assessment){

    const data = await saveEmployeeAssessment(assessment);
    
    return data ;
 };